<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-sheet class="card-rounded">
                <v-row no-gutters>
                    <!-- ระดับชั้นที่ต้องการสมัคร -->
                    <v-col cols="12" class="pa-4">
                        <v-row no-gutters justify="space-between" class="mb-3">
                            <span class="header-text">{{ $t('message.adminPage.addressInfo.address') }}</span>
                            <v-btn
                                color="primary"
                                small
                                outlined
                                @click="onAction()"
                                class="square-btn"
                            >
                                <v-icon small>
                                    {{
                                        currentStep == 5
                                            ? "mdi-eye"
                                            : "mdi-pencil"
                                    }}</v-icon
                                >
                            </v-btn>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-row no-gutters
                                    ><span class="caption-text">
                                        <v-icon color="secondary" small
                                            >mdi-map-marker</v-icon
                                        >
                                        {{ $t('message.adminPage.addressInfo.legalAddress') }}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text ml-5">{{
                                        addressDetail(applicant?.national_address, locale)
                                    }}</span></v-row
                                >
                                <div v-if="expandDetail">
                                    <v-divider class="my-4"></v-divider>
                                    <v-row no-gutters
                                        ><span class="caption-text">
                                            <v-icon color="secondary" small
                                                >mdi-map-marker</v-icon
                                            >
                                            {{ $t('message.adminPage.addressInfo.presentAddress') }}</span
                                        ></v-row
                                    >
                                    <v-row no-gutters
                                        ><span class="default-text ml-5">{{
                                            addressDetail(applicant?.current_address, locale)
                                        }}</span></v-row
                                    >
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
import { RegistrationStatusEnum } from "@/constants";
import i18n from '@/i18n';
export default {
    props: {
        applicantInfo: Object,
        currentStep: String,
    },
    computed: {
        locale() {
            return i18n.locale;
        },
        expandDetail() {
            if (
                (this.applicant?.registrationStatus ==
                    RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION_DETAIL ||
                    this.applicant?.registrationStatus ==
                        RegistrationStatusEnum.SUCCESSFUL_ENROLLMENT) &&
                (this.currentStep == 3 || this.currentStep == 5)
            )
                return true;
            return false;
        },
    },
    mounted() {
        this.retrievedData();
    },
    data() {
        return {
            applicant: {},
        };
    },
    methods: {
        retrievedData() {
            let applicant = JSON.parse(JSON.stringify(this.applicantInfo));
            this.applicant = applicant;
        },
        onAction() {
            let action = this.currentStep == 5 ? "view" : "edit";
            this.$emit(`onAction`, action, `address`);
        },
        addressDetail(address){
            let output = ""
            if(address == null || address == undefined){
                return output
            }
            output += address?.address
            if(address?.province?.value == "BANGKOK"){
                output += this.locale == "th" ? " เขต" : " District "
                output += address?.subdistrict?.[`name_${this.locale}`]
                output += this.locale == "th" ? " แขวง" : " Sup-district "
                output += address?.district?.[`name_${this.locale}`] + " "
                output += address?.province?.[`name_${this.locale}`] + " "
                output += address?.postal_code
            }
            else{
                output += this.locale == "th" ? " ตำบล" : " District "
                output += address?.subdistrict?.[`name_${this.locale}`]
                output += this.locale == "th" ? " อำเภอ" : " Sup-district "
                output += address?.district?.[`name_${this.locale}`] + " "
                output += address?.province?.[`name_${this.locale}`] + " "
                output += address?.postal_code
            }
            return output
        }
    },
};
</script>

<style scoped lang="scss">
.square-btn {
    min-width: 36px !important;
    width: 36px !important;
    height: 36px !important;
}
.header-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #255d98;
}
.caption-text {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #9d9b9a;
}
.default-text {
    font-family: "Sarabun";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
    border-radius: 10px 10px 10px 10px;
}
</style>
